import { PageListDataSource } from './BaseDataSources';
import { ICurrency } from '../Interfaces';

export class CurrencySource extends PageListDataSource<ICurrency> {
  public constructor() {
    super('/datasource/currencies');
  }
}